import {SequenceAnnotationConfig} from 'antibodies/domain-annotation/DomainAnnotationTypes';
import {ActionOrigin} from 'constants/AnalyticsConstants';
import * as TaskRunner from 'util/TaskRunner';

/**
 * Keep in sync with AnnotateDomainSequencesTaskResult in
 * benchling/antibodies/antibody_awareness/tasks/annotate_domain_sequences_task.py.
 */
export interface AnnotateDomainSequencesResult {
  datasetId: string;
  results: Array<{sequenceId: string; error: string | null}>;
}

/**
 * Annotates existing domain sequences, resolving once the annotation task finishes.
 *
 * @param analyticsMetadata Where the user started the annotation and the event group of that action, recorded
 * on the annotation's analytics.
 */
export function annotateDomainSequences({
  sequenceIds,
  config,
  analyticsMetadata,
}: {
  sequenceIds: Array<string>;
  config: SequenceAnnotationConfig;
  analyticsMetadata: {actionOrigin: ActionOrigin; eventGroupId: string};
}): Promise<AnnotateDomainSequencesResult> {
  return TaskRunner.postJSONPromise({
    url: '/1/api/domain-sequences:annotate',
    data: {
      sequenceIds,
      componentSequenceType: config.sequenceType,
      germlineId: config.germlineId,
      folderId: config.folderId,
      geneticCode: config.geneticCode,
    },
    analyticsMetadata,
  });
}
